export default __webpack_public_path__ + "static/media/milita-offer-bottom.a7cfccb4.jpg";